<template>
    <div class="row">
        <div class="col-md-12 mg-t-10">
            <div class="card ht-100p">
                <div class="card-header d-flex align-items-center justify-content-between">
                    <h6 class="mg-b-0">Add New Officer</h6>
                    <div class="d-flex tx-18">
                        <a href="" class="link-03 lh-0"><i class="icon ion-md-refresh"></i></a>
                        <a href="" class="link-03 lh-0 mg-l-10"><i class="icon ion-md-more"></i></a>
                    </div>
                </div>
<!--                <p v-if="company.company[0] == null" align="center"><bar-loader  class="custom-class" color="#6d0606" loading="loading" :size="150" sizeUnit="px"></bar-loader></p>-->
                <vue-good-wizard
                        :steps="steps"
                        class="mb-3"
                        :onNext="nextClicked"
                        :onBack="backClicked">
                    <div slot="page1">
<!--                        <p v-if="company.company[0] == null" align="center"><bar-loader  class="custom-class" color="#6d0606" loading="loading" :size="150" sizeUnit="px"></bar-loader></p>-->
                        <Form>
                            <b-row form>
                                <b-col md="6">
                                    <b-form-group>
                                        <Label for="officerLastName">Surname <span style="color: red !important; display: inline; float: none;">*</span></Label>
                                        <b-form-input v-model="model.officerLastName" type="text" name="officerLastName" id="officerLastName"
                                                      placeholder="Surname here..."/>
                                    </b-form-group>
                                </b-col>
                                <b-col md="6">
                                    <b-form-group>
                                        <Label for="officerFirstName">First name <span style="color: red !important; display: inline; float: none;">*</span></Label>
                                        <b-form-input v-model="model.officerFirstName" type="text" name="officerFirstName" id="officerFirstName"
                                                      placeholder="First name here..."/>
                                    </b-form-group>
                                </b-col>
                                <b-col md="6">
                                    <b-form-group>
                                        <Label for="officerMiddleName">Middle Name <span style="color: red !important; display: inline; float: none;">*</span></Label>
                                        <b-form-input v-model="model.officerMiddleName" type="text" name="officerMiddleName" id="officerMiddleName"
                                                      placeholder="Middle Name here..."/>
                                    </b-form-group>
                                </b-col>
                                <b-col md="6">
                                    <b-form-group>
                                        <Label for="officerMaidenName">Mother's Maiden Name <span style="color: red !important; display: inline; float: none;">*</span></Label>
                                        <b-form-input v-model="model.officerMaidenName" type="text" name="officerMaidenName" id="officerMaidenName"
                                                      placeholder="Mother's Maiden Name here..."/>
                                    </b-form-group>
                                </b-col>
                                <b-col md="6">
                                    <b-form-group>
                                        <Label for="officerGender">Gender <span style="color: red !important; display: inline; float: none;">*</span></Label>
                                        <select v-model="model.officerGender" class="form-control">
                                            <option value="" selected="selected">- Select -</option>
                                            <option value="Male">Male</option>
                                            <option value="Female">Female</option>
                                        </select>
                                    </b-form-group>
                                </b-col>
                                <b-col md="6">
                                    <b-form-group>
                                        <Label for="officerNationality">Nationality <span style="color: red !important; display: inline; float: none;">*</span></Label>
                                        <country-select class="form-control" :countryName="true" :regionName="true" v-model="model.officerNationality" :country="model.officerNationality" topCountry="NG" />
                                    </b-form-group>
                                </b-col>
                                <b-col md="6">
                                    <b-form-group>
                                        <Label for="officerDOB">Date of Birth <span style="color: red !important; display: inline; float: none;">*</span></Label>
                                        <b-form-input v-model="model.officerDOB" type="date" name="officerDOB" id="officerDOB"
                                                      placeholder="Date of Birth here..."/>
                                    </b-form-group>
                                </b-col>
                                <b-col md="6">
                                    <b-form-group>
                                        <Label for="officerDesignation">Designation <span style="color: red !important; display: inline; float: none;">*</span></Label>
                                        <select v-model="model.officerDesignation" class="form-control">
                                            <option value="" selected="selected">- Select -</option>
                                            <option value="Director">Director</option>
                                            <option value="Signatory">Signatory</option>
                                            <option value="Director and Signatory">Director and Signatory</option>
                                            <option value="CFO">CFO</option>
                                            <option value="Finance">Finance</option>
                                            <option value="Auditor">Auditor</option>
                                            <option value="Support">Support</option>
                                            <option value="Developer">Developer</option>
                                        </select>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </Form>
                    </div>
                    <div slot="page2">
                        <Form>
                            <b-row form>
                                <b-col md="6">
                                    <b-form-group>
                                        <Label for="officerCountry">Country <span style="color: red !important; display: inline; float: none;">*</span></Label>
                                        <country-select class="form-control" :countryName="true" :regionName="true" v-model="model.officerCountry" :country="model.officerCountry" topCountry="NG" />
                                    </b-form-group>
                                </b-col>
                                <b-col md="6">
                                    <b-form-group>
                                        <Label for="officerState">State <span style="color: red !important; display: inline; float: none;">*</span></Label>
                                        <region-select class="form-control" :regionName="true" :countryName="true" v-model="model.officerState" :country="model.officerCountry" :region="model.officerState" />
                                    </b-form-group>
                                </b-col>
                                <b-col md="6">
                                    <b-form-group>
                                        <Label for="officerCity">City <span style="color: red !important; display: inline; float: none;">*</span></Label>
                                        <b-form-input v-model="model.officerCity" type="text" name="officerCity" id="officerCity"
                                                      placeholder="City here..."/>
                                    </b-form-group>
                                </b-col>
                                <b-col md="6">
                                    <b-form-group>
                                        <Label for="officerStreet">Street <span style="color: red !important; display: inline; float: none;">*</span></Label>
                                        <b-form-input v-model="model.officerStreet" type="text" name="officerStreet" id="officerStreet"
                                                      placeholder="Street here..."/>
                                    </b-form-group>
                                </b-col>
                                <b-col md="6">
                                    <b-form-group>
                                        <Label for="officerPhone">Phone Number <span style="color: red !important; display: inline; float: none;">*</span></Label>
                                        <b-form-input v-model="model.officerPhone" type="text" name="phone" id="officerPhone"
                                                      placeholder="Phone Number here..."/>
                                    </b-form-group>
                                </b-col>
                                <b-col md="6">
                                    <b-form-group>
                                        <Label for="officerEmail">Email <span style="color: red !important; display: inline; float: none;">*</span></Label>
                                        <b-form-input v-model="model.officerEmail" type="email" name="email" id="officerEmail"
                                                      placeholder="Officer Emai here..."/>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </Form>
                    </div>
                    <div slot="page3">
                        <Form>
                            <b-row form>
                                <b-col md="6">
                                    <b-form-group>
                                        <Label for="officerIDType">ID Type <span style="color: red !important; display: inline; float: none;">*</span></Label>
                                        <select v-model="model.officerIDType" class="form-control">
                                            <option value="" selected="selected">- Select -</option>
                                            <option value="Voter card">Voters card</option>
                                            <option value="National ID">National ID</option>
                                            <option value="International passport">International passport</option>
                                            <option value="Driver license">Driver license</option>
                                        </select>
                                    </b-form-group>
                                </b-col>
                                <b-col md="6">
                                    <b-form-group>
                                        <Label for="officerIDNumber">ID Number <span style="color: red !important; display: inline; float: none;">*</span></Label>
                                        <b-form-input v-model="model.officerIDNumber" type="text" name="officerIDNumber" id="officerIDNumber"
                                                      placeholder="ID Number here..."/>
                                    </b-form-group>
                                </b-col>
                                <b-col md="6">
                                    <b-form-group>
                                        <Label for="officerCity">Issue Date <span style="color: red !important; display: inline; float: none;">*</span></Label>
                                        <b-form-input v-model="model.officerIDIssueDate" type="date" name="officerIDIssueDate" id="officerIDIssueDate"
                                                      placeholder="Issue Date here..."/>
                                    </b-form-group>
                                </b-col>
                                <b-col md="6">
                                    <b-form-group>
                                        <Label for="officerStreet">Expiry Date <span style="color: red !important; display: inline; float: none;">*</span></Label>
                                        <b-form-input v-model="model.officerIDExpiryDate" type="date" name="officerIDExpiryDate" id="officerIDExpiryDate"
                                                      placeholder="Expiry Date here..."/>
                                    </b-form-group>
                                </b-col>
                                <b-col md="12">
                                    <b-form-group>
                                        <Label for="officerBVN">BVN <span style="color: red !important; display: inline; float: none;">*</span></Label>
                                        <b-form-input v-model="model.officerBVN" type="text" maxlength="11" name="BVN" id="officerBVN"
                                                      placeholder="BVN here..."/>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </Form>
                    </div>
                    <div slot="page4">
                        <Form>
                            <b-row form>
                                <b-col md="6">
                                    <b-form-group>
                                        <Label for="officerEmpName">Company Name <span style="color: red !important; display: inline; float: none;">*</span></Label>
                                        <b-form-input v-model="model.officerEmpName" type="text" name="BVN" id="officerEmpName"
                                                      placeholder="Company Name here..."/>
                                    </b-form-group>
                                </b-col>
                                <b-col md="6">
                                    <b-form-group>
                                        <Label for="officerOccupation">Occupation <span style="color: red !important; display: inline; float: none;">*</span></Label>
                                        <b-form-input v-model="model.officerOccupation" type="text" name="BVN" id="officerOccupation"
                                                      placeholder="Occupation here..."/>
                                    </b-form-group>
                                </b-col>
                                <b-col md="6">
                                    <b-form-group>
                                        <Label for="officerIndustry">Employer's Industry <span style="color: red !important; display: inline; float: none;">*</span></Label>
                                        <select v-model="model.officerIndustry" class="form-control">
                                            <option value="" selected="selected">- Select -</option>
                                            <option value="Banking">Banking</option>
                                            <option value="Civil service">Civil service</option>
                                            <option value="Construction">Construction</option>
                                            <option value="Consulting">Consulting</option>
                                            <option value="Education">Education</option>
                                            <option value="Civil service">Civil service</option>
                                            <option value="Manufacturing">Manufacturing</option>
                                            <option value="Mass Media">Mass Media</option>
                                            <option value="Health">Health</option>
                                            <option value="FMCG">FMCG</option>
                                            <option value="Transportation">Transportation</option>
                                            <option value="Information Technology">Information Technology</option>
                                            <option value="Agriculture">Agriculture</option>
                                            <option value="Telecommunication">Telecommunication</option>
                                            <option value="Oil and Gas">Oil and Gas</option>
                                            <option value="Professional services">Professional services</option>
                                            <option value="Trading">Trading</option>
                                            <option value="Insurance">Insurance</option>
                                            <option value="Financial Services">Financial Services</option>
                                            <option value="Marketing">Marketing</option>
                                            <option value="Hospitality">Hospitality</option>
                                            <option value="Retail Services">Retail Services</option>
                                            <option value="Utility">Utility</option>
                                            <option value="Postal Service">Postal Service</option>
                                            <option value="Gambling">Gambling</option>
                                            <option value="Others">Others</option>
                                        </select>
                                    </b-form-group>
                                </b-col>
                                <b-col md="6">
                                    <b-form-group>
                                        <Label for="officerEmpPhone">Employer's Phone <span style="color: red !important; display: inline; float: none;">*</span></Label>
                                        <b-form-input v-model="model.officerEmpPhone" type="text" name="officerEmpPhone" id="officerEmpPhone"
                                                      placeholder="Employer's Phone here..."/>
                                    </b-form-group>
                                </b-col>
                                <b-col md="12">
                                    <b-form-group>
                                        <Label for="officerEmpAddress">Address <span style="color: red !important; display: inline; float: none;">*</span></Label>
                                        <b-form-input v-model="model.officerEmpAddress" type="text" name="officerEmpAddress" id="officerEmpAddress"
                                                      placeholder="Address here..."/>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </Form>
                    </div>
                    <div slot="page5">
                        <strong>Please, confirm the information provided before submission.</strong>
                        <br><br>
                        <table class="table">
                            <tr>
                                <th colspan="3" class="font-weight-bolder" style="text-align: center; font-size: 14px;">Biodata</th>
                            </tr>
                            <tr>
                                <td style="font-size: 14px;">Surname:</td>
                                <td colspan="3" style="font-size: 14px;" v-if="model.officerLastName === ''" > This field is mandatory</td>
                                <td colspan="3" style="font-size: 14px;" v-else> {{model.officerLastName}}</td>
                            </tr>
                            <tr>
                                <td style="font-size: 14px;">First Name:</td>
                                <td colspan="3" style="font-size: 14px;" v-if="model.officerFirstName === ''" > This field is mandatory</td>
                                <td colspan="3" style="font-size: 14px;" v-else> {{model.officerFirstName}}</td>
                            </tr>
                            <tr>
                                <td style="font-size: 14px;">Middle Name:</td>
                                <td colspan="3" style="font-size: 14px;" v-if="model.officerMiddleName === ''" > This field is mandatory</td>
                                <td colspan="3" style="font-size: 14px;" v-else> {{model.officerMiddleName}}</td>
                            </tr>
                            <tr>
                                <td style="font-size: 14px;">Maiden Name:</td>
                                <td colspan="3" style="font-size: 14px;" v-if="model.officerMaidenName === ''" > This field is mandatory</td>
                                <td colspan="3" style="font-size: 14px;" v-else> {{model.officerMaidenName}}</td>
                            </tr>
                            <tr>
                                <td style="font-size: 14px;">Gender:</td>
                                <td colspan="3" style="font-size: 14px;" v-if="model.officerGender === ''" > This field is mandatory</td>
                                <td colspan="3" style="font-size: 14px;" v-else> {{model.officerGender}}</td>
                            </tr>
                            <tr>
                                <td style="font-size: 14px;">Nationality:</td>
                                <td colspan="3" style="font-size: 14px;" v-if="model.officerNationality === ''" > This field is mandatory</td>
                                <td colspan="3" style="font-size: 14px;" v-else> {{model.officerNationality}}</td>
                            </tr>
                            <tr>
                                <td style="font-size: 14px;">Designation:</td>
                                <td colspan="3" style="font-size: 14px;" v-if="model.officerDesignation === ''" > This field is mandatory</td>
                                <td colspan="3" style="font-size: 14px;" v-else> {{model.officerDesignation}}</td>
                            </tr>
                            <tr>
                                <th colspan="3" class="font-weight-bolder" style="text-align: center; font-size: 14px;">Contact</th>
                            </tr>
                            <tr>
                                <td style="font-size: 14px;">Country:</td>
                                <td colspan="3" style="font-size: 14px;" v-if="model.officerCountry === ''" > This field is mandatory</td>
                                <td colspan="3" style="font-size: 14px;" v-else> {{model.officerCountry}}</td>
                            </tr>
                            <tr>
                                <td style="font-size: 14px;">State:</td>
                                <td colspan="3" style="font-size: 14px;" v-if="model.officerState === ''" > This field is mandatory</td>
                                <td colspan="3" style="font-size: 14px;" v-else> {{model.officerState}}</td>
                            </tr>
                            <tr>
                                <td style="font-size: 14px;">City:</td>
                                <td colspan="3" style="font-size: 14px;" v-if="model.officerCity === ''" > This field is mandatory</td>
                                <td colspan="3" style="font-size: 14px;" v-else> {{model.officerCity}}</td>
                            </tr>
                            <tr>
                                <td style="font-size: 14px;">Street:</td>
                                <td colspan="3" style="font-size: 14px;" v-if="model.officerStreet === ''" > This field is mandatory</td>
                                <td colspan="3" style="font-size: 14px;" v-else> {{model.officerStreet}}</td>
                            </tr>
                            <tr>
                                <td style="font-size: 14px;">Phone Number:</td>
                                <td colspan="3" style="font-size: 14px;" v-if="model.officerPhone === ''" > This field is mandatory</td>
                                <td colspan="3" style="font-size: 14px;" v-else> {{model.officerPhone}}</td>
                            </tr>
                            <tr>
                                <td style="font-size: 14px;">Email:</td>
                                <td colspan="3" style="font-size: 14px;" v-if="model.officerEmail === ''" > This field is mandatory</td>
                                <td colspan="3" style="font-size: 14px;" v-else> {{model.officerEmail}}</td>
                            </tr>
                            <tr>
                                <th colspan="3" class="font-weight-bolder" style="text-align: center; font-size: 14px;">Indentification</th>
                            </tr>
                            <tr>
                                <td style="font-size: 14px;">ID Type:</td>
                                <td colspan="3" style="font-size: 14px;" v-if="model.officerIDType === ''" > This field is mandatory</td>
                                <td colspan="3" style="font-size: 14px;" v-else> {{model.officerIDType}}</td>
                            </tr>
                            <tr>
                                <td style="font-size: 14px;">ID Number:</td>
                                <td colspan="3" style="font-size: 14px;" v-if="model.officerIDNumber === ''" > This field is mandatory</td>
                                <td colspan="3" style="font-size: 14px;" v-else> {{model.officerIDNumber}}</td>
                            </tr>
                            <tr>
                                <td style="font-size: 14px;">Issue Date:</td>
                                <td colspan="3" style="font-size: 14px;" v-if="model.officerIDIssueDate === ''" > This field is mandatory</td>
                                <td colspan="3" style="font-size: 14px;" v-else> {{model.officerIDIssueDate}}</td>
                            </tr>
                            <tr>
                                <td style="font-size: 14px;">Expiry Date:</td>
                                <td style="font-size: 14px;" v-if="model.officerIDExpiryDate === ''" > This field is mandatory</td>
                                <td style="font-size: 14px;" v-else> {{model.officerIDExpiryDate}}</td>
                            </tr>
                            <tr>
                                <td style="font-size: 14px;">BVN:</td>
                                <td colspan="3" style="font-size: 14px;" v-if="model.officerBVN === ''" > This field is mandatory</td>
                                <td colspan="3" style="font-size: 14px;" v-else> {{model.officerBVN}}</td>
                            </tr>
                            <tr>
                                <th colspan="3" class="font-weight-bolder" style="text-align: center; font-size: 14px;">Employer</th>
                            </tr>
                            <tr>
                                <td style="font-size: 14px;">Occupation:</td>
                                <td colspan="3" style="font-size: 14px;" v-if="model.officerOccupation === ''" > This field is mandatory</td>
                                <td colspan="3" style="font-size: 14px;" v-else> {{model.officerOccupation}}</td>
                            </tr>
                            <tr>
                                <td style="font-size: 14px;">Company's Name:</td>
                                <td colspan="3" style="font-size: 14px;" v-if="model.officerEmpName === ''" > This field is mandatory</td>
                                <td colspan="3" style="font-size: 14px;" v-else> {{model.officerEmpName}}</td>
                            </tr>
                            <tr>
                                <td style="font-size: 14px;">Employer's Industry:</td>
                                <td colspan="3" style="font-size: 14px;" v-if="model.officerIndustry === ''" > This field is mandatory</td>
                                <td colspan="3" style="font-size: 14px;" v-else> {{model.officerIndustry}}</td>
                            </tr>
                            <tr>
                                <td style="font-size: 14px;">Employer's Phone Number:</td>
                                <td colspan="3" style="font-size: 14px;" v-if="model.officerEmpPhone === ''" > This field is mandatory</td>
                                <td colspan="3" style="font-size: 14px;" v-else> {{model.officerEmpPhone}}</td>
                            </tr>
                            <tr>
                                <td style="font-size: 14px;">Employer's Address:</td>
                                <td colspan="3" style="font-size: 14px;" v-if="model.officerEmpAddress === ''" > This field is mandatory</td>
                                <td colspan="3" style="font-size: 14px;" v-else> {{model.officerEmpAddress}}</td>
                            </tr>
                        </table>
                    </div>
                </vue-good-wizard>
                <template>
                    <loading :active.sync="officer.officerLoading"
                             :can-cancel="false"
                             color="#6d0606"
                             :is-full-page="fullPage"></loading>
                </template>
            </div><!-- card -->
        </div>
    </div><!-- row -->
</template>

<script>
    // import FlotChart from "../FlotChart";
    // Import component
    import Loading from 'vue-loading-overlay';
    // Import stylesheet
    import 'vue-loading-overlay/dist/vue-loading.css';
    import {mapState} from 'vuex'
    export default {
        name: "TopCards",
        components:{
            Loading
        },
        data(){
            return {
                officers:[],
                isLoading: true,
                fullPage: true,
                model: {
                    officerLastName: '',
                    officerFirstName: '',
                    officerMiddleName: '',
                    officerMaidenName:'',
                    officerGender:'',
                    officerNationality:'',
                    officerDesignation:'',
                    officerCountry:'',
                    officerState:'',
                    officerCity:'',
                    officerStreet:'',
                    officerPhone:'',
                    officerEmail:'',
                    officerIDType:'',
                    officerIDNumber:'',
                    officerIDIssueDate:'',
                    officerIDExpiryDate:'',
                    officerBVN:'',
                    officerEmpName:'',
                    officerOccupation:'',
                    officerIndustry:'',
                    officerEmpPhone:'',
                    officerEmpAddress:'',
                    requestType:'officer',
                    subscribe: true
                },
                steps: [
                    {
                        label: 'Biodata',
                        slot: 'page1',
                    },
                    {
                        label: 'Contact',
                        slot: 'page2',
                    },
                    {
                        label: 'Identification',
                        slot: 'page3',
                    },
                    {
                        label: 'Employer',
                        slot: 'page4',
                    },
                    {
                        label: 'Confirm',
                        slot: 'page5',
                    }
                ],
            };
        },
        methods: {
            nextClicked(currentPage) {
                console.log('next clicked', currentPage)
                if (currentPage >= this.steps.length-1)
                    this.createOfficer()
                return true; //return false if you want to prevent moving to next page
            },
            backClicked(currentPage) {
                console.log('back clicked', currentPage);
                return true; //return false if you want to prevent moving to previous page
            },
            async readOfficers(){
                await this.$store.dispatch("officer/updateOfficers", {
                    orgID: localStorage.orgID,
                    accID: localStorage.accID,
                    requestType: 'officer'
                }, {root: true})
            },
            showAlert(title, message) {
                const options = {title: title, size: 'sm'}
                this.$dialogs.alert(message, options)
                    .then(res => {
                        console.log(res) // {ok: true|false|undefined}
                    })
            },
            async createOfficer(){
                this.model.dialogs = this.$dialogs;
                if (this.model.officerLastName !== ''
                    && this.model.officerFirstName !== ''
                    && this.model.officerMiddleName !== ''
                    && this.model.officerMaidenName !== ''
                    && this.model.officerGender !== ''
                    && this.model.officerNationality !== ''
                    && this.model.officerDesignation !== ''
                    && this.model.officerCountry !== ''
                    && this.model.officerState !== ''
                    && this.model.officerCity !== ''
                    && this.model.officerStreet !== ''
                    && this.model.officerPhone !== ''
                    && this.model.officerEmail !== ''
                    && this.model.officerIDType !== ''
                    && this.model.officerIDNumber !== ''
                    && this.model.officerIDIssueDate !== ''
                    && this.model.officerIDExpiryDate !== ''
                    && this.model.officerBVN !== ''
                    && this.model.officerEmpName !== ''
                    && this.model.officerOccupation !== ''
                    && this.model.officerIndustry !== ''
                    && this.model.officerEmpPhone !== ''
                    && this.model.officerEmpAddress !== ''
                ) {
                    this.isLoading = true;
                    this.model.officerAddedBy = this.system.userInfo.id;
                    this.model.officerAddedByFirstName = this.system.userInfo.firstName;
                    this.model.officerAddedByLastName = this.system.userInfo.lastName;
                    this.model.officerOrgID = localStorage.orgID;
                    this.model.officerOrgName = this.company.company[0].orgName;
                    this.model.officerAccID = this.company.account[0].accID;
                    // API CALL
                    await this.$store.dispatch("officer/createOfficers", this.model, {root: true})
                    let res = this.officer.response
                    if( res.responseCode === '00')
                    {
                        this.readOfficers()
                        const options = {title: 'Success!', size: 'sm'}
                        this.$dialogs.alert('Officer added successfully!', options)
                            .then(res => {
                                console.log(res) // {ok: true|false|undefined}
                                this.$router.go(-1)
                            })
                    }
                }else{
                    const options = {title: 'Error!', size: 'sm'}
                    this.$dialogs.alert('Empty field detected. Please fill fields with the (*)', options)
                        .then(res => {
                            console.log(res) // {ok: true|false|undefined}
                            // this.$router.go(-1)
                        })
                }
            },
        },
        computed:{
            ...mapState([
                'system',
                'company',
                'officer'
            ])
        }
    }
</script>

<style scoped>
    @media only screen and (min-width: 900px) {
        .top-card {
            width: 103%;
        }
    }
    @media only screen and (min-width: 707px) and (max-width: 900px) {
        .top-card {
            width: 104%;
        }
    }

    @media only screen and (min-width: 517px)  and (max-width: 707px) {
        .top-card {
            width: 105%;
        }
    }

    @media only screen and (min-width: 451px)  and (max-width: 517px) {
        .top-card {
            width: 106%;
        }
    }

    @media only screen  and (max-width: 451px) {
        .top-card {
            width: 107%;
        }
    }
</style>